import { EnvConfig } from "..";

const config: EnvConfig = {
  basketBFFBaseUrl: "https://api.johnlewis.com/basket-ui",
  socialProofApi:
    "https://api.johnlewis.com/product-badging/api/v1/social-proof-messaging",
  onlineStockBaseUrl:
    "https://api.johnlewis.com/online-stock/v2/available-stock",
  // deepcode ignore HardcodedNonCryptoSecret
  onlineStockApiKey: "AIzaSyCPVuiVHB4g8dFfWlqOKZXcEZ6VyE0kEio",
  hostUrl: "https://www.johnlewis.com",
};

export default config;
